import {handleAPI, API_VERSION_ONE} from '../../itrust_common/utils/apiUtils';

export function storesLoad(filters){
  const url = `/${API_VERSION_ONE}/stores`;
  const method = 'GET'

  return {
    type: 'STORES_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function storeLoad(id, filters){
  const url = `/${API_VERSION_ONE}/stores/${id}`;
  const method = 'GET'

  return {
    type: 'STORE_LOAD',
    payload: handleAPI(url,filters,method)
  };
}

export function storeCreate(data, filters){
  const url = `/${API_VERSION_ONE}/stores`;
  const method= 'POST'
  return {
    type: 'STORE_CREATE',
    payload: handleAPI(url,filters,method, {store: {...data}})
  }
}

export function storeUpdate(data, filters){
  const url = `/${API_VERSION_ONE}/stores/${data.id}`;
  const method = "PUT"
  return {
    type: 'STORE_UPDATE',
    payload: handleAPI(url,filters,method, {store: {...data}})
  }
}

export function storeDelete(id, filters) {
  const url = `/${API_VERSION_ONE}/stores/${id}`;
  const method = 'DELETE';

  return {
    type: 'STORE_DELETE',
    payload: new Promise((resolve, reject) => {
      handleAPI(url, filters, method)
        .then(response => {
          resolve({ id: id, ...response });
        })
        .catch(err => {
          reject(err);
        });
    })
  };
}

export function storeEdit(id) {
  return {
    type: 'STORE_EDIT',
    id,
  };
}

export function storeEditCancel() {
  return {
    type: 'STORE_EDIT_CANCEL'
  };
}

export function storeId(id) {
  return {
    type: 'STORE_ID',
    id,
  };
}